import React, { Fragment, useContext } from 'react';
import { IntlProvider } from 'react-intl';
import { AppContext } from '../components/context';
import messages from './messages';

const Provider = ({children}) => {
    const {state} = useContext(AppContext);

    return (
    <IntlProvider
        locale={state.locale}
        textComponent={Fragment}
        messages={messages[state.locale]}
        >
            {children}
    </IntlProvider>
    )
}

export default Provider;